import { defineMessage } from 'services/localization';

export const messages = {
    description: defineMessage('enter_the_digit_authent_our_approvalmax_account'),
    supportText: defineMessage('if_you_have_problems_re_port_articlesupportlink'),
    fieldCodeLabel: defineMessage('enter_the_authenticator_code'),
    fieldCodePlaceholder: defineMessage('enter_the_authenticator_code_1'),
};
